module.exports = __webpack_public_path__ + "img/analyze.9153098a.svg";